import Vue from 'vue';
import Confirm from '../components/Confirm.vue';

const ConfirmConstructor = Vue.extend(Confirm);

export default async function (data) {
    return new Promise((resolve, reject) => {

        let confirmDom = new ConfirmConstructor({
            el: document.createElement('div')
        })

        // new一个对象，然后插入body里面
        document.body.appendChild(confirmDom.$el);

        if (typeof data == 'string') {
            confirmDom.text.msg = data;
        } else {
            confirmDom.text = {
                ...confirmDom.text,
                ...data,
            };
        }

        const close = confirmDom.close;

        // 重写事件，用来触发Promise
        confirmDom.ok = function () {
            resolve()
            close();

        }

        confirmDom.close = function () {
            reject()
            close();

            confirmDom.$nextTick( ()=> {
                console.log('销毁');
                confirmDom.$destroy();
            })
        }
    })
}
